import { getAccessTokenFromLocal } from "Services/helpers"
import { NOTIFICATIONTYPE } from "Store/Notification/ActionTypes"
import { API_URL } from "./Constants"

const APIMiddleware = ({ dispatch, getState }: any) => {
    return (next: any) => async (action: any) => {
      const {
        types,
        callAPI,
        shouldCallAPI = () => true,
        shouldRequestInBackground = () => false,
        payload = {}
      } = action
  
      const isNormalAction = !types;
      if (isNormalAction) {
        return next(action)
      }
  
      if (
        !Array.isArray(types) ||
        types.length !== 3 ||
        !types.every(type => typeof type === 'string')
      ) {
        throw new Error('Expected an array of three string types.')
      }
  
      if (typeof shouldCallAPI === 'function' && !shouldCallAPI(getState())) {
        return;
      }
  
      const [requestType, successType, failureType] = types

      dispatch(
        Object.assign({}, payload, {
          type: requestType,
          payload: {
            ...payload,
            shouldRequestInBackground: shouldRequestInBackground(getState())
          }
        })
      )

      if (action?.notification?.NOTIFICATIONTYPE_LOADING) {
        dispatch(
          Object.assign({}, payload, {
            payload: {
              message: action.notification[NOTIFICATIONTYPE.LOADING]
            },
            type: NOTIFICATIONTYPE.LOADING
          })
        )
      }

      const accessToken = getAccessTokenFromLocal();

      if (typeof callAPI == 'object') {
        const payloadObject = {
          method: callAPI?.method || "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        };

        if (callAPI?.body) payloadObject['body'] = JSON.stringify(callAPI.body);
        if (callAPI?.formData) payloadObject['body'] = callAPI.formData;

        const hasParralel = action?.parralel?.types;
        if (hasParralel) {
          dispatch(action?.parralel);
        }

        return fetch(API_URL + callAPI.url, payloadObject).then(
          (response: any) => {
            response.json().then((data: any) => {
              if (data.code >= 500) {
                console.log('---------------------');
                console.log('ERROR');
                console.log('---------------------');
                return;
              }

              if (action?.notification) {
                  dispatch(
                    Object.assign({}, payload, {
                      payload: {
                        message: action.notification[NOTIFICATIONTYPE.SUCCESS]
                      },
                      type: NOTIFICATIONTYPE.SUCCESS
                    })
                  )
              }

              const hasCallback = action?.callback?.types;
              if (hasCallback) {
                dispatch(action?.callback);
              }
  
              dispatch(
                Object.assign({}, payload, {
                  payload: data,
                  type: successType
                })
              )
            }).catch(e => {
              console.log(e);
              if (action?.notification) {
                dispatch(
                  Object.assign({}, payload, {
                    payload: {
                      message: action.notification[NOTIFICATIONTYPE.ERROR]
                    },
                    type: NOTIFICATIONTYPE.ERROR
                  })
                )
              }
            });
          },
          (error: any) => {
            console.log('ERROR: ', error);
            error.json().then((data: any) => {
              dispatch(
                Object.assign({}, payload, {
                  payload: data,
                  type: failureType
                })
              )
            });
          }
        ).catch(e => {
          if (action?.notification) {
            dispatch(
              Object.assign({}, payload, {
                payload: {
                  message: action.notification[NOTIFICATIONTYPE.ERROR]
                },
                type: NOTIFICATIONTYPE.ERROR
              })
            )
          }
        })
      }

      return callAPI(accessToken).then(
        (response: any) => {
          response.json().then((data: any) => {
            if (action?.notification) {
                dispatch(
                  Object.assign({}, payload, {
                    payload: {
                      message: action.notification[NOTIFICATIONTYPE.SUCCESS]
                    },
                    type: NOTIFICATIONTYPE.SUCCESS
                  })
                )
            }

            const hasCallback = action?.callback?.types;
            if (hasCallback) {
              dispatch(action?.callback);
            }

            dispatch(
              Object.assign({}, payload, {
                payload: data,
                type: successType
              })
            )
          }).catch(e => {
            if (action?.notification) {
              dispatch(
                Object.assign({}, payload, {
                  payload: {
                    message: action.notification[NOTIFICATIONTYPE.ERROR]
                  },
                  type: NOTIFICATIONTYPE.ERROR
                })
              )
            }
          });
        },
        (error: any) => {
          error.json().then((data: any) => {
            dispatch(
              Object.assign({}, payload, {
                payload: data,
                type: failureType
              })
            )
          });
        }
      ).catch(e => {
        if (action?.notification) {
          dispatch(
            Object.assign({}, payload, {
              payload: {
                message: action.notification[NOTIFICATIONTYPE.ERROR]
              },
              type: NOTIFICATIONTYPE.ERROR
            })
          )
        }
      })
    }
}

export default APIMiddleware;